{"PARSED_BASE_VERSION_FOR_NEW_REDIRECTION":1310,"PARSED_BASE_VERSION_FOR_NEW_REDIRECTION_IOS":21}